import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'resourceFilter'
})
export class ResourcesPipe implements PipeTransform {
  transform(ans: any[], searchText: string): any[] {
    if(!ans) return [];
    if(!searchText) return ans;
     searchText = searchText.toLowerCase();
    var a= ( 
            ans.filter(it => it.resource.toLowerCase().includes(searchText) ||
                              it.title.toLowerCase().includes(searchText)
            ));
     return a;





   }

}
